export default __webpack_public_path__ + "static/media/ic_bus_block.eb71318a.svg";